import { getIndustry } from "@/content/industries";
import { ogImage, OG_SIZE } from "@/lib/og";

export const alt = "AI agents for your industry — Quto AI";
export const size = OG_SIZE;
export const contentType = "image/png";

// Title mirrors the page's openGraph title (`AI Agents for ${name}`); falls back
// to the section headline for unknown slugs.
export default async function Image({
  params,
}: {
  params: Promise<{ slug: string }>;
}) {
  const { slug } = await params;
  const industry = getIndustry(slug);
  const title = industry
    ? `AI Agents for ${industry.name}`
    : "AI Agents by Industry";
  return ogImage({ title, eyebrow: "Industries" });
}
